<div
  [qimaShadowLevel]="shadowService.shadowLevel.TWO"
  class="account-menu"
  qimaShadow
>
  @if (parentCompanyName) {
    <div class="account-menu__master qima-pb-s">
      <div class="account-menu__master__sub">{{ 'APP_HEADER.ACCOUNT.SUB_ACCOUNT_OF' | translate }}</div>
      <div
        [qimaAutoTooltipHasArrow]="true"
        [qimaAutoTooltipPosition]="qimaTooltip.position.BOTTOM"
        [qimaAutoTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
        [qimaAutoTooltipStyle]="qimaTooltip.style.DARK"
        [qimaAutoTooltipText]="parentCompanyName"
        class="account-menu__master__name"
        qimaAutoTooltip
      >
        {{ parentCompanyName }}
      </div>
    </div>
  }

  <div class="account-menu__user-info">
    <div class="account-menu__user-info__icon">
      <qima-icon [qimaIconName]="qimaIcon.iconName.USER"></qima-icon>
    </div>

    <div class="qima-ml-s">
      <div class="account-menu__user-info__name">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
      <div class="account-menu__user-info__name-label">{{ currentUser.login }}</div>
    </div>
  </div>
  @if (profileMenuItems.length) {
    <div
      class="account-menu__items"
      role="menu"
    >
      @for (item of profileMenuItems; track item.path; let index = $index) {
        @if (!(isBroker && index === 1)) {
          <div
            (click)="onAccountMenuItemClick(item)"
            (keydown.enter)="onAccountMenuItemClick(item)"
            (keydown.space)="$event.preventDefault(); onAccountMenuItemClick(item)"
            class="account-menu__items__item"
            role="menuitem"
            tabindex="0"
            [attr.data-cy]="'account-menu-item-' + item.label"
          >
            <span class="account-menu__items__item__label">{{ item.label | translate }}</span>
          </div>
        }
      }
    </div>
  }
  <div
    (click)="logout()"
    (keydown.enter)="logout()"
    class="account-menu__logout"
    data-cy="account-menu-logout"
  >
    <qima-icon
      [qimaIconName]="qimaIcon.iconName.LOGOUT"
      class="account-menu__logout__avatar"
    ></qima-icon>
    <span class="account-menu__logout__label">{{ 'APP_HEADER.ACCOUNT.LOGOUT' | translate }}</span>
  </div>
</div>
